/**
 * 中文语言包
 * 页面内静态文案全部放在此处，按业务模块拆分以防冲突
 */
import common from './modules/common';

import homepage from './modules/homepage';
import about from './modules/about';
import roleManage from './modules/roleManage';
import userManage from './modules/userManage';

export default {
    common,
    homepage,
    about,
    roleManage,
    userManage,
};
